module.exports = __webpack_public_path__ + "img/detail_portrait_default_women@3x.50cda27a.png";